import i18n from 'i18next';

import {AuditPhotos} from './AuditPhotos';

export const ConditionPhotos = () => (
  <AuditPhotos notFoundText={i18n.t`entity.condition.notifications.photosOfConditionNotFound`} />
);
